/**
 * Appends a querystring with imgix options
 *
 * @param {string} auto - The auto parameter helps you automate a baseline level of optimization across your entire image catalog.
 * @param {string} background - Color to fill in any transparent areas
 * @param {string} crop - Crop mode controls how the image is aligned when fit=crop is set.
 * @param {string} fit - The fit parameter controls how the output image is fit to its target dimensions after resizing, and how any background areas will be filled.
 * @param {string} format - The output format to convert the image to.
 * @param {(number|string)[]} heights - An array of heights
 * @param {string} mask - Sets the type of mask from a pre-defined list of shapes, or from a transparent image URL.
 * @param {number|string} quality - Controls the output quality of lossy file formats (jpg, pjpg, webp, or jxr).
 * @param {string} src - The image url
 * @param {(number|string)[]} widths - An array of widths
 */

const generateImgixSrc = ({ src, width, height, format, background, quality, auto, fit, mask }) => {
    const bg = background?.indexOf('#') === 0 ? background.slice(1) : background;

    const awsS3Url = process.env.REACT_APP_AWS_S3_URL;
    const isSvg = src?.endsWith('.svg');
    const isData = src?.startsWith('data:');
    const isPath = src?.startsWith('/'); //Used for e.g. placeholders

    if (src && !isData && !isPath) {
        //To avoid using imgix for SVGs, we replace imgix url w AWS S3 link for the same image.
        if (isSvg) {
            const svgUrl = new URL(src);
            const newSvgUrl = `${awsS3Url}${svgUrl.pathname}`;

            //Update src with the aws S3 url.
            src = newSvgUrl;

            //Append imgix query string
        } else {
            const strippedSrc = src.split('?');
            return `${strippedSrc[0]}?q=${quality}${fit ? `&fit=${fit}` : ''}${width ? `&w=${width}` : ''}${
                height ? `&h=${height}` : ''
            }${format ? `&fm=${format}` : ''}${bg ? `&bg=${bg}` : ''}${auto ? `&auto=${auto}` : ''}${
                mask ? `&mask=${mask}` : ''
            }`;
        }
    }

    return src ? src : bg ? bg : undefined;
};

export default generateImgixSrc;
